import { State } from '@progress/kendo-data-query';
import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { isEmpty } from 'lodash';
import { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import ExportExcel, { ExcelOption, defaultExcelOption } from 'src/components/ExportExcel';
import ClearFilterButton from 'src/components/design-system/ClearFilterButton';
import { SetState } from 'src/types/generic';

interface GridToolbarProps {
  dataState: State;
  clearFilter: () => void;
  excelExport: (page: number) => void;
  setExportLoading: SetState<boolean>;
  isOpenTransaction?: boolean;
}

const CheckbookBalanceToolBar: FC<GridToolbarProps> = ({
  clearFilter,
  excelExport,
  setExportLoading,
  dataState,
  isOpenTransaction,
}) => {
  const [excelOption, setExcelOption] = useState(defaultExcelOption);
  const transactionDialogRef = useRef(null);

  const isFilterDisable = useMemo(
    () => isEmpty(dataState.filter?.filters),
    [dataState.filter?.filters]
  );

  const handleExcelChange = useCallback(
    (e: DropDownListChangeEvent) => {
      const selectedOption: ExcelOption = e.target.value;
      setExcelOption(selectedOption);
      if (selectedOption.value === 1 || selectedOption.value === 2) {
        setExportLoading(true);
        excelExport(selectedOption.value);
        setExcelOption(defaultExcelOption);
        setExportLoading(false);
      }
    },
    [excelExport, setExportLoading]
  );
  useEffect(() => {
    if (isOpenTransaction && transactionDialogRef.current) {
      (transactionDialogRef?.current as any).focus();
    }
  }, [isOpenTransaction]);
  return (
    <div className="flex items-center justify-between w-full">
      <ClearFilterButton disabled={isFilterDisable} onClick={clearFilter} />
      <button ref={transactionDialogRef} style={{ height: 0, width: 0 }} />
      <div className="flex flex-row gap-4">
        <ExportExcel excelOption={excelOption} onExcelChanged={handleExcelChange} width={200} />
      </div>
    </div>
  );
};
export default CheckbookBalanceToolBar;
